/**
 * @fileoverview Agent definition for pov-suggester-v2.
 *
 * Suggests suitable narrative points of view based on a story blurb.
 *
 * @category narrative.story.metadata
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'pov-suggester-v2',
  kind: 'primitive',
  name: 'POV Suggester',
  description: 'Suggests suitable narrative points of view based on a story blurb.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.metadata',
    usedBy: ['use-story-suggestions.ts', 'story-pov-card.tsx'],
    relatedAgents: ['plot-type-suggester-v2'],
  },
};
